import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refDownloadFrameworkStrategyPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={'AI駆動開発 AI RDRA DDD SDD フレームワーク'}
          image={'https://aitria.co.jp/img/ogp_logo.png'}
          url={'https://aitria.co.jp/download/framework-strategy/done/'}
          title="ご入力いただきありがとうございます | AI時代の開発フレームワーク戦略 | 資料ダウンロード | Aitria（アイトリア）"
          description="ご入力いただいたメールアドレス宛に資料ダウンロード用URLを送付いたしました。メールをご確認いただき、資料をダウンロードしてください。"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
